import React from 'react';
import { object, string } from 'yup';

import Cabecalho from 'Component/Admin/Cabecalho';
import { useToast } from 'Component/Alerta';
import Form, { Botao, Campo } from 'Component/Form';
import Icone from 'Component/Icone';
import LayoutDefault from 'Component/Layout';
import Usuario from 'Interface/Usuarios';
import { useEditarUsuarioMutation, useRecuperarUsuarioQuery } from 'Service';
import { useAppSelector } from 'Store';

const regras = object({
    senha: string().required('Obrigatório'),
});

const AlterarMinhaSenha = (): React.ReactElement =>
{
    const toast = useToast();
    const usuario = useAppSelector(estado => estado.autenticacao.usuario);
    const { data, isLoading } = useRecuperarUsuarioQuery(usuario?.id || 0);
    const [ editarUsuario ] = useEditarUsuarioMutation();

    const enviar = async (dados: Usuario): Promise<void> =>
    {
        try {
            await editarUsuario(dados).unwrap();

            toast({ conteudo: 'Senha alterada com sucesso!', tema: 'success' });
        } catch (error) {
            toast({
                titulo: 'Erro ao alterar senha',
                conteudo: 'Verifique os logs para maiores detalhes.',
                tema: 'danger',
            });
        }
    }

    return (
        <LayoutDefault>
            <Cabecalho
                titulo="Alterar senha"
                descricao="Altere o formulário e clique em enviar para editar a sua senha"
            />
            <Form onSubmit={ enviar } inicial={ data?.usuario } desabilitado={ isLoading } regras={ regras }>
                <div className="row">
                    <div className="col-md-4">
                        <div className="bg-white shadow-sm rounded p-4">
                            <div className="row">
                                <div className="col-md-12">
                                    <Campo
                                        type="password"
                                        name="senha"
                                        rotulo="Senha"
                                        prefixar={ <Icone nome="lock-fill" /> }
                                    />
                                </div>
                            </div>

                            <div className="mt-5">
                                <Botao>Enviar</Botao>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </LayoutDefault>
    )
}

export default AlterarMinhaSenha;
